import { ASSESSMENT_MODALITY } from '../../constants/measure';

/**
 * Returns true if there is at least one playlist with online item
 * @param {array} playlists array of student playlists
 */
const playlistsHaveOnlineItem = (playlists) =>
    playlists && playlists.length > 0 && playlists.some(playlist => (
        playlist.playlist_items.some(
            item => item.modality === ASSESSMENT_MODALITY.ONLINE
        )
    ));

export default playlistsHaveOnlineItem;
